import Navbar from "@/components/landing/Navbar";
import ScrollHero from "@/components/landing/ScrollHero";
import RentDiscovery from "@/components/landing/RentDiscovery";
import Features from "@/components/landing/Features";
import Journey from "@/components/landing/Journey";
import HomeIQScore from "@/components/landing/HomeIQScore";
import VastuIntro from "@/components/landing/VastuIntro";
import CTA from "@/components/landing/CTA";
import Footer from "@/components/landing/Footer";
import Header from "@/components/persistent/Header";
import DecisionDashboard from "@/components/persistent/DecisionDashboard";
import LegalModal from "@/components/persistent/LegalModal";
import AffordabilityTab from "@/pages/AffordabilityTab";
import LoanRepaymentTab from "@/pages/LoanRepaymentTab";
import MarketIntelligenceTab from "@/pages/MarketIntelligenceTab";
import InvestmentInsightsTab from "@/pages/InvestmentInsightsTab";
import VastuTab from "@/pages/VastuTab";
import { HomeIQProvider, useHomeIQ } from "@/homeiq/state/HomeIQContext";

function Landing() {
    return (
        <>
            <Navbar />
            <ScrollHero />
            <RentDiscovery />
            <Features />
            <Journey />
            <HomeIQScore />
            <VastuIntro />
            <CTA />
            <Footer />
        </>
    );
}

function Shell({ children }) {
    // Wrap in a div so the mobile Generate Report bar's fixed height can
    // be offset with bottom padding covering BOTH the main content and
    // the Footer that sits below it. Padding is 0 on ≥md where the CTA
    // lives inline in the DecisionDashboard.
    return (
        <div
            data-testid="shell-root"
            className="pb-[calc(4.5rem+env(safe-area-inset-bottom))] md:pb-0"
        >
            <Header />
            <DecisionDashboard />
            <main data-testid="shell-main" className="bg-white text-[#0A1F44]">
                {children}
            </main>
            <Footer />
        </div>
    );
}

function Router() {
    const { activeSection } = useHomeIQ();
    if (activeSection === "home") return <Landing />;
    const tabs = {
        affordability: <AffordabilityTab />,
        market: <MarketIntelligenceTab />,
        investment: <InvestmentInsightsTab />,
        loan: <LoanRepaymentTab />,
        vastu: <VastuTab />,
    };
    return <Shell>{tabs[activeSection] ?? null}</Shell>;
}

export default function Landing_Page() {
    return (
        <HomeIQProvider>
            <div data-testid="landing-page" className="bg-white text-[#0A1F44] min-h-screen relative">
                <Router />
                <LegalModal />
            </div>
        </HomeIQProvider>
    );
}
